import React, { useState } from "react";
import "../../styles/sections/financingCard.scss";
import WhatsAppModal from "../WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { buildWhatsAppUrl, getCurrentUrlWithUtmDefaults, getUtmParams } from "../../config/whatsappConfig";
import { sendToTecnom } from "../../config/tecnomApi";

const FinancingCard = ({
  banco,
  logo,
  color,
  etiquetas,
  titulo,
  tasa,
  tasaDestacada,
  detalle,
  detalleDestacado,
  link,
}) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleWhatsAppClick = () => {
    setOpen(true);
  };

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      const utms = getUtmParams();
      await updateData({
        ...values,
        ...utms,
        url: window.location.href,
      });
      setOpen(false);
      const urlWithUtm = getCurrentUrlWithUtmDefaults();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;

      // Enviar lead a Tecnóm (tarjeta financiación -> modal WhatsApp)
      try {
        await sendToTecnom({
          brand: "GAC",
          name: values.nombre,
          email: values.email,
          phone: values.celular,
          comments: `Consulta financiación${banco ? ` - Banco: ${banco}` : ""}`,
          tipoPlan: "venta directa",
          utm_source: utms.utm_source,
          utm_medium: utms.utm_medium,
          utm_campaign: utms.utm_campaign,
          campaign: "GAC_FINANCIACION",
        });
      } catch (tecnomError) {
        console.error("Error al enviar a Tecnóm:", tecnomError);
      }

      window.location.href = buildWhatsAppUrl(whatsappMessage);
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="financing-card">
      <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
        {logo && <img src={logo} alt={banco} className="financing-card-logo" />}
      </div>
      <div className="financing-chips-container" style={{ marginBottom: 12 }}>
        {etiquetas &&
          etiquetas.map((et, i) => (
            <span key={i} className="financing-chip">
              {et}
            </span>
          ))}
        {tasaDestacada && <span className="financing-chip tasa">{tasaDestacada}</span>}
      </div>
      <div style={{ marginBottom: 12, marginTop: 12 }}>
        <p className="financing-card-title">
          {titulo}{" "}
          {tasa && (
            <span className="financing-card-tasa">
              {tasa} {detalle && <span className="financing-card-detalle">{detalle}</span>}
            </span>
          )}
        </p>
        {detalleDestacado && <div className="financing-card-detalle-destacado">{detalleDestacado}</div>}
      </div>
      <div>
        <button onClick={handleWhatsAppClick} className="financing-card-btn" disabled={loading}>
          Consultá ahora <span>→</span>
        </button>
      </div>
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
    </div>
  );
};

export default FinancingCard;

